import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { RoutePaths } from 'Interfaces/RoutePaths';
import StorageService from 'Services/Storage';
import { WORKFLOW_PREFIX } from 'Utils/constants';

interface CustomRedirectProps {
  to: string;
  isAuth?: boolean;
  replace?: boolean;
}

const CustomRedirect = ({ to, isAuth, replace }: CustomRedirectProps) => {
  const location = useLocation();
  let redirectRoute = to;

  if (!isAuth && location?.pathname && location?.pathname !== RoutePaths.BASE_PATH) {
    const pathName = location.pathname;
    const route = pathName.slice(WORKFLOW_PREFIX.length, pathName.length);
    StorageService.setRedirectRoutePath(route);
  }

  if (isAuth) {
    redirectRoute = StorageService.getRedirectRoutePath()
      ? `${WORKFLOW_PREFIX}${StorageService.getRedirectRoutePath()}`
      : to;
    StorageService.removeRedirectRoutePath();
  }

  return <Navigate to={redirectRoute} replace={replace} />;
};

export default CustomRedirect;
